import { Button, Dialog, DialogActions, DialogContent, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { onHandlerDeleteView } from '../handler/ViewHandler';

export const DialogConfirmDeleteView = (props) => {
    const onCloseConfirm = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }

        props.setIsConfirmDeleteView(false);
    };

    return (
        <Dialog
            open={props.isConfirmDeleteView}
            onClose={(event, reason) => onCloseConfirm(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirm-dialog-content">
                    ビューを削除して宜しいでしょうか？
                    <IconButton
                        className="close"
                        onClick={(event, reason) => onCloseConfirm(event, reason)}
                    >
                        <CloseIcon />
                    </IconButton>
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button className="confirm-dialog-button" variant="contained" color="primary" onClick={() => onHandlerDeleteView(props.view, props)}>
                    はい
                </Button>
                <Button
                    className="confirm-dialog-button"
                    variant="contained"
                    color="primary"
                    onClick={(event, reason) => onCloseConfirm(event, reason)}
                >
                    いいえ
                </Button>
            </DialogActions>
        </Dialog>
    );
};
